import native from "c-up-native";
import Cache from "c-cache";
import url from "c-url";
import notification from "c-notification";
let system = native.getSystem();
let platform = native.getPlatform();

let cache = new Cache({
  prefix: "uplive",
});
//国外域名
let externalListDomains = ["m.upliveapps.com", "awsbj-game2u.xingyunzhi.cn"];
let isExternal = externalListDomains.indexOf(document.domain) > -1;

//下载链接从接口取
const originMap = {
  pro: "https://liveapi.upliveapps.com/uplive/get-download-settings",
  stage: "https://sg-liveapi.pengpengla.com/uplive/get-download-settings",
};
let download = {
  downloadUrl: {
    yyb: "",
    apple: "",
    google: "",
    android: "",
  },
  load() {
    // 当前开发环境
    var env = url.query("env");

    if (!env || env == "null") {
      env = "pro";
    }

    let API = originMap[env] || originMap["pro"];
    let feature = url.query("feature") || 0;
    let promise = $.ajax({
      url: API,
      type: "POST",
      dataType: "json",
      data: {
        feature,
      },
    });

    promise.done((res) => {
      let { yyb, ios, googleplay, apk } = res.data.download_url;

      this.downloadUrl = {
        yyb: yyb,
        apple: ios,
        google: googleplay,
        android: apk,
      };
    });
  },
};
// if(!isExternal){

download.load();
// }
// let externalDownloadUrl =  {
//         'ios': 'https://app.adjust.com/c4hn47',
//         'android': 'https://app.adjust.com/gjk5bm',
//         'pc': 'https://app.adjust.com/gjk5bm'
//     }

let dl = () => {
  //debugger;
  let feature = url.query("feature") || 0;
  if (feature == "10001") {
    if (system == "ios") {
      location.href = "https://apps.apple.com/app/6473873074";
    } else {
      notification.simple(lang.template("当前版本不支持下载"));
    }
    return;
  }
  if (feature == "10002") {
    notification.simple(lang.template("当前版本不支持下载"));
    return;
  }

  let dynamicId = url.query("dynamicId") || 0;
  let rid = url.query("rid") || 0;
  let env = url.query("env") || "pro";
  let target;
  cache.setCache("goDownload", 1);
  if (platform == "wechat" || platform == "qq") {
    //解决ios点击下载回退不刷新问题
    cache.setCache("isNeedReload", 1);
  }
  if (system == "ios") {
    native.openDynamicCallApp({ rid, dynamicId });
    return;
  }
  // else if (platform == 'wechat' || platform == 'qq') {
  //     target = download.downloadUrl.yyb;
  // }else if(platform == 'fb' || platform == 'line'){
  //     target = download.downloadUrl.google;
  // } else {
  //     target = download.downloadUrl.android ;
  // }
  let lang = url.query("lang");
  let urlOrigin = location.origin;
  if (location.host == "awsbj-game2u.xingyunzhi.cn") {
    urlOrigin += "/up";
  }
  if (feature == "6666") {
    if (dynamicId && rid) {
      target =
        urlOrigin +
        "/hayapro/download.html" +
        `?env=${env}&from=dynamic&rid=${rid}&dynamicId=${dynamicId}`;
    } else {
      target = urlOrigin + "/hayapro/download.html";
    }
  } else if (feature == "1002") {
    if (dynamicId && rid) {
      target =
        urlOrigin +
        "/dominouppro/download.html?lang=" +
        lang +
        `&env=${env}&feature=${feature}&from=dynamic&rid=${rid}&dynamicId=${dynamicId}`;
    } else {
      target =
        urlOrigin +
        "/dominouppro/download.html?lang=" +
        lang +
        "&feature=" +
        feature;
    }
  } else {
    if (dynamicId && rid) {
      target =
        urlOrigin +
        "/uppro/download.html?lang=" +
        lang +
        `&env=${env}&feature=${feature}&from=dynamic&rid=${rid}&dynamicId=${dynamicId}`;
    } else {
      if (feature == "1001") {
        target =
          urlOrigin +
          "/ludouppro/download.html?lang=" +
          lang +
          "&feature=" +
          feature;
      } else if (feature == "1002") {
        target =
          urlOrigin +
          "/dominouppro/download.html?lang=" +
          lang +
          "&feature=" +
          feature;
      } else {
        target =
          urlOrigin +
          "/uppro/download.html?lang=" +
          lang +
          "&feature=" +
          feature;
      }
    }
  }
  location.href = target;
};

export default dl;



// WEBPACK FOOTER //
// ./js/component/download/dl.js